/**
 * PhaseBar — per-phase progress bars for StatusHeader (FR-A07).
 * Renders a mini horizontal bar per phase showing completed/total as a filled percentage.
 * Zero additional queries — data comes from the existing `phases` array in api.tasks.status.
 */

interface PhaseData {
  phase: number;
  name: string;
  total: number;
  complete: number;
}

interface PhaseBarProps {
  phases: PhaseData[];
}

export function PhaseBar({ phases }: PhaseBarProps) {
  if (!phases || phases.length === 0) return null;

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-2">
      {phases.map((p) => {
        const pct = p.total > 0 ? Math.round((p.complete / p.total) * 100) : 0;
        return (
          <div key={p.phase} className="space-y-0.5">
            <div className="flex items-center justify-between">
              <span className="text-xs text-zinc-400 font-mono truncate">
                {p.name}
              </span>
              <span className="text-xs text-zinc-500 font-mono tabular-nums ml-1 shrink-0">
                {p.complete}/{p.total}
              </span>
            </div>
            <div className="h-1.5 bg-gray-200 dark:bg-zinc-800 rounded-full overflow-hidden">
              <div
                className="h-full rounded-full transition-all duration-500"
                style={{
                  width: `${pct}%`,
                  backgroundColor:
                    pct === 100 ? "#22c55e" : "#3b82f6", // green-500 when done, blue-500 otherwise
                }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}
